export const GET_PUNCHH_SETUP_CONFIG_REQUESTED = 'brand/GET_PUNCHH_SETUP_CONFIG_REQUESTED';
export const GET_PUNCHH_SETUP_CONFIG_SUCCESS = 'brand/GET_PUNCHH_SETUP_CONFIG_SUCCESS';
export const GET_PUNCHH_SETUP_CONFIG_FAILURE = 'brand/GET_PUNCHH_SETUP_CONFIG_FAILURE';

export const UPDATE_PUNCHH_SETUP_CONFIG_REQUESTED = 'brand/UPDATE_PUNCHH_SETUP_CONFIG_REQUESTED';
export const UPDATE_PUNCHH_SETUP_CONFIG_SUCCESS = 'brand/UPDATE_PUNCHH_SETUP_CONFIG_SUCCESS';
export const UPDATE_PUNCHH_SETUP_CONFIG_FAILURE = 'brand/UPDATE_PUNCHH_SETUP_CONFIG_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  punchhConfiglist: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_PUNCHH_SETUP_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        punchhConfiglist: [],
      };
    }
    case GET_PUNCHH_SETUP_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        punchhConfiglist: action.result,
      };
    }
    case GET_PUNCHH_SETUP_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case UPDATE_PUNCHH_SETUP_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_PUNCHH_SETUP_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_PUNCHH_SETUP_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getPunchhConfig = (brandId) => {
  return {
    types: [GET_PUNCHH_SETUP_CONFIG_REQUESTED, GET_PUNCHH_SETUP_CONFIG_SUCCESS, GET_PUNCHH_SETUP_CONFIG_FAILURE],
    promise: client => client.get(`getPunchhConfig/${brandId}`)
  };
};

export const updatePunchhConfig = (brandId, data) => {
  return {
    types: [UPDATE_PUNCHH_SETUP_CONFIG_REQUESTED, UPDATE_PUNCHH_SETUP_CONFIG_SUCCESS, UPDATE_PUNCHH_SETUP_CONFIG_FAILURE],
    promise: client => client.post(`updatePunchhConfig/${brandId}`, { data })
  };
};
